import React from 'react';
import {MainWrapper, Layout} from './MindBody.Styles';
import {Header} from '../../components/organisms/Header/Header';
import {StickyNavigationLink} from '../../components/organisms/StickyNavigationLinks/StickyNavigationLinks'
import {MainContent} from '../../components/organisms/MainContent/MainContent';
import {RightScan} from '../../components/organisms/RightScan/RightScan';

export const MindBody: React.FC = () => {
    const tag = 'mente e corpo';

    return(
    <Layout>
      <Header />
      <StickyNavigationLink onSearch={(tag) => console.log(tag)} />
      <MainWrapper>
        <MainContent tag={tag}/>
        <RightScan />
      </MainWrapper>
    </Layout>
    );
};